export default __webpack_public_path__ + "static/media/Gellix-MediumItalic.2868ff58.woff2";